// extracted by mini-css-extract-plugin
export default {"container":"Favorite_container__rYgot","icon":"Favorite_icon__Pv37C","counter":"Favorite_counter__5kcxq"};